import React from 'react'
import { Link } from 'react-router-dom';
import './Emploi.css'
function Emploi() {
  return (
    <>
    <div className='messageriebox'>
        <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Emploi du temps</p>
        <hr/>   
        <div className='filiereemploidutemps' style={{marginLeft:'10px'}}>
            <h6>Filiére :</h6> 
            <p>Ingénieur en informatique</p>
        </div>
        <div className='filiereemploidutemps' style={{marginLeft:'10px'}}>
            <h6>Niveau :</h6> 
            <p>1</p>
        </div>
        <div style={{marginLeft:'10px'}}>
        <Link >Télécharger l'Emploi</Link>
 
        </div>
    </div>
    
    </>
  )
}

export default Emploi